import React, { createRef, useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Videojs from "../video-js";
import Image from "../../elements/image";
import BodyText from "../../elements/body-text";
import PrimaryButton from "../../elements/primary-button";
import { mobileIs } from "../../utils/siteUtils";

import "./style.scss";
const ShowRoom = props => {
  const { lang, fields, page } = props;
  const { title, des, image, imageMobile, video, videoMobile, btn, icon, btnColor, link, titleSize, paddingAboveBottom, paddingAboveTop } = fields; 
  const rootEl = useRef(null);
  const isAR = page?.fields?.rtl?.value;
  const videoEl = useRef(null);
  const isMobile = mobileIs()
	let newLink = JSON.parse(JSON.stringify(link))
	const [btnProps, setBtnProps] = useState({});
  const videoOptions =
		(( !isMobile && video && video.value) || ( isMobile && videoMobile && videoMobile.value))
			? {
					sources: [
						{
							src: isMobile ? videoMobile.value.src : video.value.src,
							type: isMobile ? videoMobile.value.mimeType : video.value.mimeType
						}
					],
					poster: isMobile ? imageMobile.value.src : image.value.src,
					videoTitle: '',
					loop: true,
					autoplay: true,
					controls: false,
					muted: true
				}
			: null;
	const videoEnded = () => {
		if(!isMobile){
			videoEl.current.player.play()
		}
	}
  const handleScroll = useCallback(() => {
    let elem = rootEl.current;
    if (elem === undefined) {
      return;
    }
    let rect = elem.getBoundingClientRect();
    let winHeight = window.innerHeight || document.documentElement.clientHeight;
    if(rect.top < (winHeight/2) &&  Math.abs(rect.top) < winHeight ){
			if(!isMobile){
				setTimeout(() => {
					if(videoEl?.current){
						videoEl.current.player.play()
					}
				}, 10 );
			}
    }else{
			videoEl.current.player.pause()
		}
  }, [])
	useEffect(() => {
		if( videoEl && videoEl.current && !isMobile ){
			setTimeout(v=>{
				if( videoEl && videoEl.current && !isMobile ){
					videoEl.current.player.play()
				}
			},10)
		}
		setTimeout(v=>{
			newLink.value.href = `${newLink.value.href}`
			newLink.value.url = `${newLink.value.url}`
			setBtnProps({
				colorScheme: btnColor,
				iconName: icon,
				buttonText: btn,
				link: newLink
			})
		})
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
	},[])
  let size = titleSize ? titleSize?.fields?.phrase?.value : "default";
  return (
		<div className={classNames("show-room")} ref={rootEl}>
			{ !videoOptions && 
				<img className="show-room-img" src={isMobile?imageMobile.value.src:image.value.src}/>
			}
			{ videoOptions &&
					<Videojs ref={videoEl} videoEnded={videoEnded} className="show-room-video" {...videoOptions}/>
			}
			<div className="show-room-content">
				{ title && title.value &&
					<BodyText className={classNames("show-room-title",size)} html={title.value} />
				}
				{ des && des.value &&
					<BodyText className="show-room-des" html={des.value} />
				}
			</div>
				{ btn && btn.value &&
					<div className="show-room-btn">
						{link.value && <PrimaryButton {...btnProps} />}
					</div>
				}
				<div className="mask"></div>
		</div>
  );
};
export default ShowRoom;
